import type { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import { classes } from './utils';

export interface PanelProps extends PropsWithChildren {
  className?: string;
  side: 'left' | 'right';
}

export default function Panel({ className, side, children }: PanelProps) {
  return (
    <div className={twMerge(classes.base, classes[side], className)}>
      {children}
    </div>
  );
}
